import TabsRouter from './src/tabs-router';

export default TabsRouter;
